<script>
    import FButtonSectionContent from "./FButtonSectionContent";

    export default {
        props: {
            to: {
                type: String,
                default: "/"
            },
            href: {
                type: String,
                default: "#"
            },
            icon: {
                type: String,
                default: "check"
            },
            title: {
                type: String,
                default: "Titulo"
            },
            descr: {
                type: String,
                default: "Descrição do botão"
            }
        },

        components: { FButtonSectionContent }
    };
</script>

<template>
    <router-link v-if='to' :to='to' class='fluid__link'>
        <FButtonSectionContent :title='title' :icon='icon' :descr='descr'/>
    </router-link>
    <a v-else :href='href' class='fluid__link'>
        <FButtonSectionContent :title='title' :icon='icon' :descr='descr'/>
    </a>
</template>

<style scoped>
    .fluid__link {
        all: unset;
        text-decoration: none;
        cursor: pointer;
        max-width: 400px;
    }
</style>
